module.exports = __webpack_public_path__ + "static/gcp-d0567605624e21241ab510cd07af4b63.png";